import { useAtomValue } from 'jotai'

import { isAuthenticated } from './auth'

export function useIsAuthentication() {
  const value = useAtomValue(isAuthenticated)
  return value
}
